import axios from "axios";
import { getAuth } from "firebase/auth";

import JobResponse from "../models/JobResponse";

const GET_RESPONSES_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net/get_responses_by_vacancy";

const DELETE_RESPONSE_URL =
  "https://europe-west3-hyper-e122e.cloudfunctions.net/delete_response";

async function getAuthHeaders() {
  const auth = getAuth();
  const user = auth.currentUser;

  if (!user) {
    throw new Error(
      "Пользователь не авторизован"
    );
  }

  /*
    true заставляет Firebase обновить токен,
    если старый уже протух.
  */
  const token = await user.getIdToken(true);

  console.log(
    "🔐 Firebase token получен:",
    token ? `${token.slice(0, 20)}...` : "нет"
  );

  return {
    "Content-Type": "application/json",
    Authorization: `Bearer ${token}`
  };
}

const ResponsesService = {
  async getResponses(vacancyId) {
    console.log(
      "📡 Загружаем отклики для вакансии ID:",
      vacancyId
    );

    if (!vacancyId) {
      console.warn(
        "❌ getResponses вызван без vacancyId"
      );

      return [];
    }

    try {
      const headers =
        await getAuthHeaders();

      const response = await axios.post(
        GET_RESPONSES_URL,
        {
          vacancy_id: vacancyId
        },
        {
          headers
        }
      );

      console.log(
        "📥 Полный ответ getResponses:",
        response.data
      );

      const rawResponses =
        response.data?.responses || [];

      return rawResponses.map(
        item => new JobResponse(item)
      );
    } catch (error) {
      console.error(
        "❌ Ошибка при получении откликов:",
        {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message
        }
      );

      throw error;
    }
  },

  async viewResponse(responseId) {
    console.log("👁 Mark response as viewed. responseId:", responseId);
  
    if (!responseId) {
      throw new Error("Не передан responseId");
    }
  
    try {
      const headers = await getAuthHeaders();
  
      const response = await axios.post(
        "https://europe-west3-hyper-e122e.cloudfunctions.net/view_response",
        {
          response_id: responseId,
        },
        { headers }
      );
  
      console.log("✅ view_response result:", response.data);
      return response.data;
    } catch (error) {
      console.error("❌ Ошибка при view_response:", {
        status: error.response?.status,
        data: error.response?.data,
        message: error.message,
      });
      throw error;
    }
  },

  async deleteResponse(responseId) {
    console.log(
      "🗑 Удаляем отклик с ID:",
      responseId
    );

    if (!responseId) {
      throw new Error(
        "Не передан responseId"
      );
    }

    try {
      const headers =
        await getAuthHeaders();

      const response = await axios.post(
        DELETE_RESPONSE_URL,
        {
          response_id: responseId
        },
        {
          headers
        }
      );

      console.log(
        "✅ Отклик удалён:",
        response.data
      );

      return response.data;
    } catch (error) {
      console.error(
        "❌ Ошибка при удалении отклика:",
        {
          status: error.response?.status,
          data: error.response?.data,
          message: error.message
        }
      );

      throw error;
    }
  }
};

export default ResponsesService;